import type { FC } from 'react'
import { useState, useContext } from 'react'
import styled from 'styled-components'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import TextInput from '@/components/input/TextInput'
import ctx from '@/context/AppContext'
import { useAddAccountantRefereeMutation } from '@/lib/apollo'
import { Colours } from '@/utils/styles'

const ErrorContainer = styled.div`
  strong {
    color: ${Colours.red};
  }
`

interface Props {
  customerId: string
  subjectId: string
  incomeId: string
  onClose: () => void
}

const AddAccountantReferenceSidebar: FC<Props> = ({
  customerId,
  subjectId,
  incomeId,
  onClose,
}) => {
  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [phone, setPhone] = useState<string>('')

  const { personId } = useContext(ctx)

  const [handleAddAccountantReferee, { data, loading, error }] =
    useAddAccountantRefereeMutation()

  return (
    <SlideInSidebar
      onClose={onClose}
      header={<h1>Add accountant referee</h1>}
      content={
        data ? (
          <>This accountant referee has been added.</>
        ) : (
          <>
            <>
              Please provide the details of the accountant referee you would like to add.
            </>
            <TextInput
              type="text"
              label="Name"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setName(e.target.value)
              }}
              value={name}
            />
            <TextInput
              type="text"
              label="Email"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(e.target.value)
              }}
              value={email}
            />
            <TextInput
              type="text"
              label="Phone"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPhone(e.target.value)
              }}
              value={phone}
            />
          </>
        )
      }
      footer={
        <>
          {error?.message && <ErrorContainer>{error?.message}</ErrorContainer>}
          <div>
            <AlternateButton onClick={onClose}>Cancel</AlternateButton>
            {!data && (
              <Button
                disabled={loading || name === '' || email === '' || phone === ''}
                onClick={() =>
                  handleAddAccountantReferee({
                    variables: {
                      customerId,
                      subjectId,
                      userId: personId ?? '',
                      email,
                      name,
                      phone,
                      incomeId,
                    },
                  })
                }
              >
                Confirm
              </Button>
            )}
          </div>
        </>
      }
    />
  )
}

export default AddAccountantReferenceSidebar
